import './components.css';

const SintJozefPost = () => {
    return (
        <div className='custom-body'>
            <div className='card h-100 custom-card'>
                <img
                    src='./img-intern/wzc-sint-jozef.jpg'
                    alt='WZC Sint Jozef'
                    className='card-img-top post-img'
                />
                <div className='card-body'>
                    <h5 className='card-title'>WZC Sint-Jozef</h5>
                    <div className='card-text'>
                        Waar we woonzorgverblijf, kortverblijf, nachtopvang en
                        crisisopvang aanbieden.
                    </div>
                    <a
                        href='https://www.zorgnetwerktrento.be/onze-dienstverlening'
                        target='_top'
                        className='btn btn-primary stretched-link'
                    >
                        Lees Meer
                    </a>
                </div>
            </div>
            <p className='adres'>Het adres is Molenstraat 11, 9220 Moerzeke.</p>
            <iframe
                title='Locatie WZC Sint-Jozef'
                src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d626.8771867077263!2d4.150530488152759!3d51.062158041569916!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c393d2eed8c889%3A0xf8de8cda840b5739!2sMolenstraat%2011%2C%209220%20Hamme!5e0!3m2!1snl!2sbe!4v1617620260028!5m2!1snl!2sbe'
                width='400'
                height='250'
                style={{ border: '0' }}
                allowfullscreen=''
                loading='lazy'
            ></iframe>
        </div>
    );
};

export default SintJozefPost;
